import { useEffect } from "react";
import { useUnsavedStore } from "../stores/unsavedStore";

/** Registers `dirty` in the unsaved store and blocks tab close/reload while dirty. Returns the nudge counter so the owner can flash its save bar. */
export function useUnsavedGuard(dirty: boolean): { nudge: number } {
  const setDirty = useUnsavedStore((s) => s.setDirty);
  const nudge = useUnsavedStore((s) => s.nudge);
  useEffect(() => { setDirty(dirty); return () => setDirty(false); }, [dirty, setDirty]);
  useEffect(() => {
    if (!dirty) return;
    // returnValue as well: Safari only prompts when it is set.
    const h = (e: BeforeUnloadEvent) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", h);
    return () => window.removeEventListener("beforeunload", h);
  }, [dirty]);
  return { nudge };
}

/**
 * The `Tabs.guard` every tab strip above an editor passes (ADR 403): refuses the switch
 * while a section reports unsaved edits and nudges it so it can flash its save bar.
 * Shared by the warehouse tabs (Modelo/Mapa/Estrutura) and the Estrutura sub-tabs.
 */
export function unsavedTabGuard(): boolean {
  const s = useUnsavedStore.getState();
  if (!s.dirty) return true;
  s.bump();
  return false;
}
